// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IZAZs","top":"styles_top__2AYEF","left":"styles_left__3ngzc","description":"styles_description__2y-9G"};